import type { CSSProperties, ComponentProps } from "react"

/**
 * Invisible trigger for the pointer menu's own `DropdownMenu`. Radix
 * positions the content against this element, so pinning it to the click
 * point is what makes the menu open at the pointer and flip to stay on
 * screen, the same as the real three-dot trigger does against its button.
 *
 * Used through `DropdownMenuTrigger asChild`, which hands its ref and props
 * to this component; they must reach the span, or Radix has nothing to
 * measure and the menu opens in the wrong place.
 */
export function PointerMenuAnchor({
  point,
  style,
  ...rest
}: { point: { x: number; y: number } | null } & ComponentProps<"span">) {
  if (!point) return null
  const pinned: CSSProperties = {
    ...style,
    position: "fixed",
    left: point.x,
    top: point.y,
    width: 0,
    height: 0,
    pointerEvents: "none",
  }
  return <span aria-hidden {...rest} style={pinned} />
}
